import React, {PropsWithChildren} from 'react';
import { ExclamationCircle } from "../../assets/svg/exclamation-circle.icon";
import styled from "styled-components";
import {useServices} from "../../hooks/use-services.hook";


export const MaintenanceMessageBox = styled.div`
    display: flex;
    align-items: flex-start;
    font-size: ${props => props.theme.fontSize.h6};
    color: ${props => props.theme.colors.warningContrast};
    background-color: ${props => props.theme.colors.warning};
    padding: ${props => props.theme.spacing.spacing16};
    
    margin:${props => props.theme.spacing.spacing16} ${props => props.theme.spacing.spacing24};
    border-radius: 8px;
    
    svg {
        flex-shrink: 0;
        margin-right: 8px;
    }
`
interface MaintenanceAnnouncementComponentProps extends PropsWithChildren {
    className?: string;
}
export const MaintenanceAnnouncementComponent: React.FC<MaintenanceAnnouncementComponentProps> = (props) => {
    const services = useServices();
    if (!services.maintenance.data.enableMaintenanceAnnouncement) {
        return <></>;
    }

    const startIsoDate = services.time.parseIsoDate(services.maintenance.data.startDate!)
    const endIsoDate = services.time.parseIsoDate(services.maintenance.data.endDate!)

    const startDate = services.time.formatUserFriendlyDate(startIsoDate);
    const startHour = services.time.formatHHmm(startIsoDate);
    const endHour = services.time.formatHHmm(endIsoDate);
    const weekDayAbbreviation = services.time.getDayFullName(startIsoDate.getDay());
    return (
        <MaintenanceMessageBox className={props.className}>
            <ExclamationCircle size={1.6} />
            <span>
                {services.language.translationFor(`Our website is undergoing scheduled maintenance on {weekDayAbbreviation} {startDate}, from {startHour} to {endHour}. During this period booking, check-in and manage my booking functions will be unavailable.`)
                    .withParams({
                        startDate: startDate,
                        weekDayAbbreviation: weekDayAbbreviation,
                        startHour: startHour,
                        endHour: endHour,
                    })
                }
            </span>

        </MaintenanceMessageBox>
    );
}
